import React, { useEffect, useState } from "react";
import "./Print_Media_inner.css";
import Breadcrumbs_Holder from "../../Common_Component/Breadcrumbs_Holder/Breadcrumbs_Holder";
import Get_In_Touch from "../All_services_inner/Video_Wala_Bus_Stand/Video_Wala_Bus_Stand_inner_content/Get_In_Touch/Get_In_Touch";
import Billboards_and_Hoardings from "./Billboards_and_Hoardings/Billboards_and_Hoardings";
import How_It_Works from "./How_It_Works/How_It_Works";
import Print_Media_Benefits from "./Print_Media_Benefits/Print_Media_Benefits";
import Print_Media_Why_Choose_Us from "./Print_Media_Why_Choose_Us/Print_Media_Why_Choose_Us";
import { useParams } from "react-router-dom";
import Banner from "../Digital_Media_Services_Inner/Banner/Banner";

function Print_Media_inner() {
  const [data, setData] = useState(); const [imgSrc, setImgSrc] = useState("");
  const [billData, setBillData] = useState()

  const { id } = useParams()

  const breadcrumbs = [
    { label: "Print Media", link: "/services-inner/4", active: false },
    {
      label: billData?.title,
      link: "",
      active: true,
    },
  ];


  const get_in_touch = {
    getInTouch_Title: "Ready to make your  ",
    getInTouch_Titl2: "brand unmissable? ",
    getInTouch_Descn: "Let’s create a billboard or hoarding campaign that drives results. Contact us today to get started!",
    getInTouch_Img: "/Assets/Images/Service/Services/Video_Wala_Bus_Stand/Get_In_Touch/printMedia.png",
    vidowala: false,
  }


  const why_choose_data = [
    {
      title: "Creative Expertise",
      subtext: "Our designers specialize in creating logos that are creative, meaningful, and aligned with your brand.",
      imgSrc: "/Assets/Images/Service/Services/Branding/why_choose/img1.png"
    },
    {
      title: "Collaborative Process",
      subtext: "We involve you at every step to ensure your satisfaction.",
      imgSrc: "/Assets/Images/Service/Services/Branding/why_choose/img2.png"
    },
    {
      title: "Attention to Detail",
      subtext: "From typography to colour palette, we focus on every element to create a cohesive design.",
      imgSrc: "/Assets/Images/Service/Services/Branding/why_choose/img3.png"
    },
    {
      title: "Quick Turnaround",
      subtext: "Get your logo delivered promptly without compromising on quality.",
      imgSrc: "/Assets/Images/Service/Services/Branding/why_choose/img4.png"
    },
  ]

  const rightImg = "/Assets/Images/Service/Services/printmedia/why_choose/rightImg.png"

  const bordData = [
    {
      id: 1,
      title: "Billboards and Hoardings",
      description: "Billboards and hoardings are powerful tools for high-impact outdoor advertising. With large, eye-catching visuals & strategic placements...",
      image: "/Assets/Images/Service/Services/printmedia/banner2.png",
      baseLink: "/print-Media-services"
    },

    {
      id: 2,
      title: "Bus Wrapping",
      description: "Bus wrapping is a dynamic and eye-catching advertising solution that turns public transportation into moving billboards.",
      image: "/Assets/Images/Service/Services/printmedia/banner2.png",
      baseLink: "/print-Media-services"
    },

    {
      id: 3,
      title: "Bus Shelter",
      description: "Bus shelter advertising transforms every day waiting areas into prime advertising spaces.",
      image: "/Assets/Images/Service/Services/printmedia/banner2.png",
      baseLink: "/print-Media-services"
    },

    {
      id: 4,
      title: "Auto Rikshaw Back",
      description: "Auto rickshaw back advertising is a cost-effective and impactful way to promote your brand across urban and suburban areas.",
      image: "/Assets/Images/Service/Services/printmedia/banner2.png",
      baseLink: "/print-Media-services"
    },

    {
      id: 5,
      title: "Brochures and Flyers",
      description: "Bus wrapping is a dynamic and eye-catching advertising solution that turns public transportation into moving billboards.",
      image: "/Assets/Images/Service/Services/printmedia/banner2.png",
      baseLink: "/print-Media-services"
    },

    {
      id: 6,
      title: "Leaflets",
      description: "Leaflets are simple, cost-effective marketing tools that are perfect for delivering concise, targeted messages to your audience.",
      image: "/Assets/Images/Service/Services/printmedia/banner2.png",
      baseLink: "/print-Media-services"
    },

    {
      id: 7,
      title: "Catalogues",
      description: "Catalogues are powerful marketing tools designed to showcase your products, services, or offerings in a professional, organized, and visually...",
      image: "/Assets/Images/Service/Services/printmedia/banner2.png",
      baseLink: "/print-Media-services"
    },

    {
      id: 8,
      title: "Banners",
      description: "Banners are a versatile and impactful advertising tool that can be used for a variety of purposes, from promoting events to displaying special offers.",
      image: "/Assets/Images/Service/Services/printmedia/banner2.png",
      baseLink: "/print-Media-services"
    },

    {
      id: 9,
      title: "Roll-up Standees",
      description: "Roll-up standees are an efficient and highly portable solution for displaying your brand, products, or promotions in a variety of settings.",
      bgImgSrc: "/Assets/Images/Service/Services/printmedia/rollup.png",
      MainImgSrc: "/Assets/Images/Service/Services/printmedia/img9.png",
      baseLink: "/print-Media-services"
    },

    {
      id: 10,
      title: "Sun Boards",
      description: "Sun boards are a durable and lightweight material perfect for outdoor and indoor signage.",
      image: "/Assets/Images/Service/Services/printmedia/banner2.png",
      baseLink: "/print-Media-services"
    },

    {
      id: 11,
      title: "Newspaper Inserts",
      description: "Newspaper inserts are a highly effective way to target a broad audience by placing promotional materials directly inside newspapers.",
      bgImgSrc: "/Assets/Images/Service/Services/printmedia/NEWSPAPER-INSERTS.png",
      MainImgSrc: "/Assets/Images/Service/Services/printmedia/img11.png",
      baseLink: "/print-Media-services"
    },

    {
      id: 12,
      title: "Labels and Stickers",
      description: "Labels & stickers are powerful marketing tools that offer versatility and brand visibility in a fun, creative, and cost-effective way.",
      image: "/Assets/Images/Service/Services/printmedia/banner2.png",
      baseLink: "/print-Media-services"
    }

  ]




  useEffect(() => {

    const filteredArray = bordData.find(
      (item) => item.id === Number(id)
    );
    setData(filteredArray || {});

    console.log("filteredArray", filteredArray, id)

    setBillData(filteredArray || {});

    const bannerImages = {
      1: "/Assets/Images/Banners/Billboards/Billboards.png",
      2: "/Assets/Images/Banners/PPC/PPC.png",
      3: "/Assets/Images/Banners/web_dev/web_dev.png",
    };
    setImgSrc(
      bannerImages[id] ||
      "/Assets/Images/Banners/Billboards/Billboards.png"
    );
  }, [id])



  return (
    <>
      <section className="Print_Media_inner">
        <div className="cotainer">
          <Banner imgSrc={imgSrc} />

          <Breadcrumbs_Holder breadcrumbs={breadcrumbs} data={data} />

          <Billboards_and_Hoardings billBoardData={billData} />

          <How_It_Works />

          <Print_Media_Benefits />

          <Print_Media_Why_Choose_Us why_choose_data={why_choose_data} rightImg={rightImg} />

          <Get_In_Touch vidowala={get_in_touch?.vidowala != undefined ? get_in_touch?.vidowala : true} getInTouch_Img={get_in_touch?.getInTouch_Img} getInTouch_Title={get_in_touch?.getInTouch_Title} getInTouch_Titl2={get_in_touch?.getInTouch_Titl2} getInTouch_Descn={get_in_touch?.getInTouch_Descn} />
        </div>
      </section>
    </>
  );
}

export default Print_Media_inner;
